import { render } from "./BlogDetailsThreePage.vue?vue&type=template&id=a64bd5b6"
import script from "./BlogDetailsThreePage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsThreePage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__